import { LoginForm } from "../../component";
// import Api from "../../Api";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Api from "../../Api";
import { setIsLoggedIn, updateUserInfo } from "../../redux/User";

const Login = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const api = Api();
  return (
    <>
      <LoginForm
        onLogin={(username: string, password: string) => api.user.login(username, password)}
        onLoginSuccess={(response: any) => {
          dispatch(updateUserInfo(response.data));
          dispatch(setIsLoggedIn(true));
          navigate(location.state?.from?.pathname || "/", {
            replace: true,
          });
        }}
      />
    </>
  );
};

export default Login;
